import styled from '@emotion/styled';
import { Checkbox, Field, FieldList, TextInput, tokens } from '@hotjar/hotsauce';

export const S = {
  Form: styled.form`
    grid-column-start: 2;
  `,
  Field: styled(Field)`
    width: 100%;
  `,
  FieldList: styled(FieldList)`
    width: 100%;
  `,
  CheckboxContainer: styled.span`
    display: flex;
  `,
  Checkbox: styled(Checkbox)`
    width: auto;
  `,
  TextInput: styled(TextInput)`
    margin-top: ${tokens.spacer.x1};
  `,
};
